import {useContext} from 'react';

import {UseOfContextWithoutProviderError} from '@/types/errors';
import {NewDocumentCreationContext} from './new-document-creation.context';

export const useNewDocumentCreation = () => {
  const context = useContext(NewDocumentCreationContext);

  if (!context) {
    throw new UseOfContextWithoutProviderError('NewDocumentCreation');
  }

  return context;
};
